const SAVE_CONFIG = 'SAVE_CONFIG';
export default SAVE_CONFIG;
